import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import StatsSection from './components/StatsSection';
import ArticlesSection from './components/ArticlesSection';
import FAQSection from './components/FAQSection';

const homepageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '注册送彩金 - 首页',
  description: '注册送彩金活动火热进行中！新用户完成注册即可免费领取专属彩金，无需存款即可体验。',
  url: 'https://www.example.com/',
  isPartOf: {
    '@type': 'WebSite',
    name: '注册送彩金',
    url: 'https://www.example.com',
  },
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(homepageJsonLd)}</script>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <StatsSection />
        <ArticlesSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}